import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Container } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import AddAirport from '../../../../../ProgramOnboarding/Components/SelectAirport/Components/AddAirport';
import { CREATE_AIRPORT_V2, GET_COORDINATES_EMPTY, UPDATE_AIRPORT_V2 } from '../../../../../../../../../store/actions';
import { useDispatch } from 'react-redux';
import { ChevronLeft } from 'react-feather';

const initialState = {
  name: null,
  code: '',
  latitude: '',
  placeId: '',
  longitude: '',
  address: '',
  terminals: [{ name: null, latitude: '', longitude: '', placeId: '' }],
};

const AddAndUpdateAirport = ({ currentSelectedInventory, onClose, isUpdate }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [airport, setAirport] = useState(initialState);
  const [errors, setErrors] = useState({
    name: '',
    code: '',
    latitude: '',
    longitude: '',
    terminals: [], // Array of objects per terminal
  });

  useEffect(() => {
    if (currentSelectedInventory) {
      setAirport({
        name: {
          value: currentSelectedInventory?.id,
          label: currentSelectedInventory?.name,
          completeData: { placeId: currentSelectedInventory?.placeId },
        },
        placeId: currentSelectedInventory?.placeId,
        address: currentSelectedInventory?.address,
        code: currentSelectedInventory?.code,
        latitude: currentSelectedInventory?.latitude,
        longitude: currentSelectedInventory?.longitude,
        terminals: currentSelectedInventory?.terminals?.map(terminal => {
          return {
            name: {
              value: terminal?.name,
              label: terminal?.name,
              completeData: { placeId: terminal?.placeId },
            },
            latitude: terminal?.latitude, // Get Terminal Coordinates API Field: latitude
            longitude: terminal?.longitude, // Get Terminal Coordinates API Field: longitude
            placeId: terminal?.placeId,
          };
        }) ?? [{ name: null, latitude: '', longitude: '', placeId: '' }],
      });
    }
  }, [currentSelectedInventory]);

  const validateAirport = airport => {
    const newErrors = {
      name: airport.name ? '' : 'Airport name is required',
      code: airport.code ? '' : 'Airport code is required',
      latitude: airport.latitude ? '' : 'Latitude is required',
      longitude: airport.longitude ? '' : 'Longitude is required',
      terminals: [],
    };

    airport.terminals.forEach((terminal, i) => {
      const tErrors = {
        name: terminal.name ? '' : 'Name required',
        latitude: terminal.latitude ? '' : 'Latitude required',
        longitude: terminal.longitude ? '' : 'Longitude required',
      };
      newErrors.terminals.push(tErrors);
    });

    setErrors(newErrors);

    // check if any error exists
    const hasError =
      Object.values(newErrors).some(val => typeof val === 'string' && val !== '') ||
      newErrors.terminals.some(t => Object.values(t).some(v => v !== ''));

    return hasError;
  };

  const handleAirport = () => {
    const error = validateAirport(airport);
    if (error) {
      return; // prevent adding
    }

    if (isUpdate) {
      const payload = {
        name: airport?.name?.label ?? '',
        code: airport?.code?.toUpperCase() ?? '',
        latitude: airport?.latitude,
        longitude: airport?.longitude,
        address: airport?.address ?? '',
        placeId: airport?.name?.completeData?.placeId ?? '',
        terminals:
          airport?.terminals?.map(terminal => {
            return {
              name: terminal?.name?.value,
              latitude: terminal?.latitude,
              longitude: terminal?.longitude,
              placeId: terminal?.name?.completeData?.placeId || terminal?.placeId,
            };
          }) ?? [],
      };

      dispatch({
        type: UPDATE_AIRPORT_V2,
        payload: {
          data: { ...payload, id: currentSelectedInventory?.id },
        },
      });
    } else {
      const payload = {
        name: airport?.name?.completeData?.structuredFormatting?.mainText ?? '', // Find Airports API Field: main_text
        code: airport?.code?.toUpperCase() ?? '',
        latitude: airport?.latitude, // Get Airport Coordinates API Field: latitude
        longitude: airport?.longitude, // Get Airport Coordinates API Field: longitude
        address: airport?.name?.completeData?.structuredFormatting?.secondaryText ?? '',
        placeId: airport?.name?.completeData?.placeId ?? '', // Find Airports API Field: place_id
        terminals:
          airport?.terminals?.map(terminal => {
            return {
              name: terminal?.name?.value, // Find Airports API Field: structuredFormatting-> main_text
              latitude: terminal?.latitude, // Get Terminal Coordinates API Field: latitude
              longitude: terminal?.longitude, // Get Terminal Coordinates API Field: longitude
              placeId: terminal?.name?.completeData?.placeId, // Find Terminals API Field: place_id
            };
          }) ?? [],
      };

      dispatch({
        type: CREATE_AIRPORT_V2,
        payload: {
          data: payload,
        },
      });
    }
  };

  return (
    <Card className="p-3">
      <CardHeader tag="h5" className="border-bottom pb-2">
        {isUpdate ? 'Update Airport' : 'Add Airport'}{' '}
      </CardHeader>
      <CardBody>
        <AddAirport airport={airport} setAirport={setAirport} errors={errors} setErrors={setErrors} isUpdate={isUpdate} />
        <div className="d-flex justify-content-between mt-4">
          <Button
            onClick={() => {
              setAirport(initialState);
              onClose();
            }}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <Button className="btn btn-primary" color="primary" onClick={handleAirport}>
            {isUpdate ? 'Update Airport' : 'Add Airport'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default AddAndUpdateAirport;
